"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _taggedTemplateLiteral2 = _interopRequireDefault(require("@babel/runtime/helpers/taggedTemplateLiteral"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _react = _interopRequireWildcard(require("react"));

var _reactRouterDom = require("react-router-dom");

var _propTypes = _interopRequireDefault(require("prop-types"));

var _styledTheming = _interopRequireDefault(require("styled-theming"));

var _styledComponents = _interopRequireWildcard(require("styled-components"));

var _Constant = require("../../Constant");

var _Text = require("../../Text");

var _TwoColumnCompanyLogos = require("./TwoColumnCompanyLogos");

var _VisuallyHidden = _interopRequireDefault(require("../../VisuallyHidden"));

var _theme;

function _templateObject2() {
  var data = (0, _taggedTemplateLiteral2.default)(["\n  background-color: initial;\n  display: inline-block;\n  ", "\n"]);

  _templateObject2 = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject() {
  var data = (0, _taggedTemplateLiteral2.default)(["\n  @media print, screen and (min-width: ", "px) {\n    width: 100%;\n    background-color: initial;\n    padding: 25px 25px 0;\n    margin-bottom: 30px;\n  }\n\n  @media print, screen and (min-width: ", "px) {\n    padding: 40px 50px 0;\n  }\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

// To allow for Windows High Contrast mode users, the logo SVGs must be inline. This allows us to have access to the styling of the SVGs and to use `currentColor` for fill and stroke so that the logos are visible in high contrast mode. Because of this, new logos will need to be added to `TwoColumnCompanyLogos` and imported here like the others.
var logoSize = (0, _styledTheming.default)('mode', (_theme = {}, (0, _defineProperty2.default)(_theme, _Constant.Themes.CALIBER, "\n    max-width: 6.8rem;\n    @media print, screen and (min-width: ".concat(_Constant.Width.MD, "px){\n      max-width: 8.6rem;\n    }\n    @media print, screen and (min-width: ").concat(_Constant.Width.LG, "px) {\n      max-width: 9.6rem;\n    })")), (0, _defineProperty2.default)(_theme, _Constant.Themes.HOMEBRIDGE, "\n    max-width: 10rem;\n    path {\n      fill: white;\n    }\n    @media print, screen and (min-width: ".concat(_Constant.Width.MD, "px){\n      max-width: 14rem;\n      path {\n        fill: #323E48;\n      }\n      path.h {\n        fill: #00A7E1\n      }\n    }\n    @media print, screen and (min-width: ").concat(_Constant.Width.LG, "px) {\n      max-width: 18rem;\n      path {\n        fill: #323E48\n      }\n      path.h {\n        fill: #00A7E1\n      }\n    })")), (0, _defineProperty2.default)(_theme, _Constant.Themes.GUARANTEED_RATE, "\n    max-width: 14rem;\n    .arrow1 {\n      fill: ".concat(_Constant.Color.WHITE, ";\n    }\n    .rate {\n      fill: ").concat(_Constant.Color.GUARANTEED_RATE_ARROW_RED, ";\n    }\n    .title {\n      fill: ").concat(_Constant.Color.WHITE, ";\n    }\n    @media print, screen and (min-width: ").concat(_Constant.Width.MD, "px){\n      max-width: 12rem;\n      .arrow1{\n        fill: ").concat(_Constant.Color.GUARANTEED_RATE_ARROW_RED, ";\n      }\n      .rate {\n        fill: ").concat(_Constant.Color.WHITE, ";\n      }\n      .title {\n        fill: ").concat(_Constant.Color.BLACK_SOUL, ";\n      }\n    }\n    @media print, screen and (min-width: ").concat(_Constant.Width.LG, "px) {\n      max-width: 30rem;\n    })")), (0, _defineProperty2.default)(_theme, _Constant.Themes.HOMEPOINT, "\n    max-width: 14rem;\n    @media print, screen and (min-width: ".concat(_Constant.Width.MD, "px){\n      max-width: 12rem;\n    }\n    @media print, screen and (min-width: ").concat(_Constant.Width.LG, "px) {\n      max-width: 16rem;\n    })")), (0, _defineProperty2.default)(_theme, _Constant.Themes.FIGURE, "\n    max-width: 6.8rem;\n    @media print, screen and (min-width: ".concat(_Constant.Width.MD, "px){\n      max-width: 8.6rem;\n    }\n    @media print, screen and (min-width: ").concat(_Constant.Width.LG, "px) {\n      max-width: 9.6rem;\n    })")), (0, _defineProperty2.default)(_theme, _Constant.Themes.SYNERGY_ONE, "\n    max-width: 10rem;\n    path {\n      fill: white;\n    }\n    @media print, screen and (min-width: ".concat(_Constant.Width.MD, "px){\n      max-width: 14rem;\n      path {\n        fill: black;\n      }\n    }\n    @media print, screen and (min-width: ").concat(_Constant.Width.LG, "px) {\n      max-width: 18rem;\n    })")), (0, _defineProperty2.default)(_theme, _Constant.Themes.PETERSENDEAN, "\n    max-width: 6.8rem;\n    @media print, screen and (min-width: ".concat(_Constant.Width.MD, "px){\n      max-width: 8.6rem;\n    }\n    @media print, screen and (min-width: ").concat(_Constant.Width.LG, "px) {\n      max-width: 9.6rem;\n    })")), (0, _defineProperty2.default)(_theme, _Constant.Themes.PELLA, "\n    max-width: 6.8rem;\n    @media print, screen and (min-width: ".concat(_Constant.Width.MD, "px){\n      max-width: 8.6rem;\n    }\n    @media print, screen and (min-width: ").concat(_Constant.Width.LG, "px) {\n      max-width: 9.6rem;\n    })")), _theme));

var Container = _styledComponents.default.div(_templateObject(), _Constant.Width.MD, _Constant.Width.LG);

var Anchor = (0, _styledComponents.default)(_Text.AnchorBase)(_templateObject2(), logoSize);

var TwoColumnLogo = function TwoColumnLogo(_ref) {
  var isRouterLink = _ref.isRouterLink,
      url = _ref.url,
      linkDescription = _ref.linkDescription;
  var themeContext = (0, _react.useContext)(_styledComponents.ThemeContext);
  var THEMED_LOGOS = (0, _defineProperty2.default)({
    caliber: /*#__PURE__*/_react.default.createElement(_TwoColumnCompanyLogos.CaliberLogo, null),
    homebridge: /*#__PURE__*/_react.default.createElement(_TwoColumnCompanyLogos.HomebridgeLogo, null),
    homepoint: /*#__PURE__*/_react.default.createElement(_TwoColumnCompanyLogos.HPLogo, null),
    figure: /*#__PURE__*/_react.default.createElement(_TwoColumnCompanyLogos.FigureLogo, null),
    petersendean: /*#__PURE__*/_react.default.createElement(_TwoColumnCompanyLogos.FigureLogo, null),
    pella: /*#__PURE__*/_react.default.createElement(_TwoColumnCompanyLogos.FigureLogo, null),
    synergyone: /*#__PURE__*/_react.default.createElement(_TwoColumnCompanyLogos.SynergyOneLogo, null)
  }, _Constant.Themes.GUARANTEED_RATE, /*#__PURE__*/_react.default.createElement(_TwoColumnCompanyLogos.GuaranteedRateLogo, null));
  return /*#__PURE__*/_react.default.createElement(Container, null, isRouterLink ? /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement(Anchor, {
    semanticElement: _reactRouterDom.Link,
    to: url,
    isUnderlined: false
  }, /*#__PURE__*/_react.default.createElement(_VisuallyHidden.default, null, linkDescription), themeContext && THEMED_LOGOS[themeContext.mode])) : /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement(Anchor, {
    href: url,
    isUnderlined: false
  }, /*#__PURE__*/_react.default.createElement(_VisuallyHidden.default, null, linkDescription), themeContext && THEMED_LOGOS[themeContext.mode])));
};

TwoColumnLogo.propTypes = {
  url: _propTypes.default.string,
  isRouterLink: _propTypes.default.bool,
  linkDescription: _propTypes.default.string
};
TwoColumnLogo.defaultProps = {
  url: '/dashboard',
  isRouterLink: false,
  // this is the description users will hear via screen reader
  linkDescription: 'go to my dashboard'
};
var _default = TwoColumnLogo;
exports.default = _default;